import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { ConfirmationModalComponent } from '../../confirmation-modal/confirmation-modal.component';

export interface MockupCanDeactivate {
  hasUnsavedChanges: boolean;
  prepareForDeactivateCheck?(): void;
}

@Injectable()
export class MockupPendingChangesGuard {
  constructor(private modalService: NgbModal) {}

  canDeactivate(
    component: MockupCanDeactivate,
    _route: ActivatedRouteSnapshot,
    _nextState?: RouterStateSnapshot
  ): boolean | Promise<boolean> {
    component.prepareForDeactivateCheck?.();

    if (!component.hasUnsavedChanges) {
      return true;
    }

    const modalRef = this.modalService.open(ConfirmationModalComponent, {
      backdrop: 'static',
      keyboard: false
    });
    modalRef.componentInstance.title = 'Unsaved Changes';
    modalRef.componentInstance.message = 'You have unsaved changes.';
    modalRef.componentInstance.subMessage = 'Are you sure you want to leave? Your changes will be lost.';
    modalRef.componentInstance.actionBtnTitle = 'Leave';
    modalRef.componentInstance.actionBtnType = 'DANGER';
    modalRef.componentInstance.cancelBtnTitle = 'Cancel';

    return modalRef.result.then(() => true).catch(() => false);
  }
}
